export {
  CommonEndpoints,
  PatientProfileEndpoints,
  PatientContactEndpoints,
  PatientPractitionerEndpoints,
  LookupEndpoints,
  PatientDocumentEndpoints,
  PractitionerEndpoints,
  AuthEndpoints,
  DocumentEndpoints,
  PatientDashboardEndpoints,
  PatientCarePlanEndpoints

} from '@medicalapp/shared-core';

export const PatientExercisePlanEndpoints = {
  PatientExercisePlans: '/patient-exercise/list',
  PatientExerciseDetails: '/patient-exercise/detail-list',
  PatientExerciseProgress: '/patient-exercise/progress-list',
};

export const PatientMessageEndpoints = {
  Messages: '/patient-portal/messages',
  MessagesManage: '/patient-portal/messages/manage',
};

export const NotificationEndpoints = {
  ModuleNotificationsCount: '/patient-portal/notifications/module-notification-count',
};
